angular.module('wbDashboard').controller('BaseControllerAurea',
    ['$scope', '$rootScope', '$sce', '$timeout', 'User', 'PlanService', 'Login', 'Display', 'Notification', 'Track', 'bugsnagClient', 'Auth',
function ($scope, $rootScope, $sce, $timeout, User, PlanService, Login, Display, Notification, Track, bugsnagClient, Auth) {
    var localData={};

    Login.timeout($scope);

    $scope.$watchCollection(User.getUserData, function (userData) {
        $scope.userData = userData;
    });

    /**
     * Initialize everything that requires the overview to function
     */
    $scope.$watch(function() { return User.get('overview'); }, function(overview) {
        if (overview) {
            localData.overview = overview;
            $scope.initDisplay();
            if (overview.user.marketing_id) {
                Track.setDistinctId(overview.user.marketing_id);
                Track.register('visitor', 'client');
            }

            if (bugsnagClient.user) {
                bugsnagClient.user.id = Auth.getClientId();
                bugsnagClient.user.email = overview.user.email;
            }

        }
    });

    $scope.$watch(function() { return Notification.modal; }, function(notification) {
        if (notification) {
            $scope.initDisplay();
        }
    });

    $scope.initDisplay = function() {
        if ($scope.$state.current.name === "base.security-update") {
            Display.setViewToMain();
        } else {
            Display.initView(localData.overview);
            Display.setNotification(Notification.modal);
        }
    };


    var currentName = "";
    var changeTimeoutPromise = null;
    //need to trigger class change animation classes for states that change which aren't using the main-view ui-view
    //eg milestone and other pages with {page} params
    $scope.stateChanged = function() {
        var changed;
        changed = $scope.$state.current.name !== currentName;
        if (changed) {
            //too many timeouts causes entire ui to lag
            $timeout.cancel(changeTimeoutPromise);
            changeTimeoutPromise = $timeout(function () {
                currentName = $scope.$state.current.name;
            }, 100);
        }
        return changed;
    };

    var inlineLoadingTimeoutPromise = null;
    //display minor loading between pages if resolves take a while
    $scope.$transitions.onStart({to: "base.**"}, function(trans) {
        if (trans.to().resolve) {
            inlineLoadingTimeoutPromise = $timeout(function() {
                //if loading is short enough, want ot skip loading page
                $scope.inlineLoading = true;
            }, 100);
        }
    });
    $scope.$transitions.onSuccess({to: "base.**"}, function(trans) {
        transitionFinally(trans);
    });
    $scope.$transitions.onError({to: "base.**"}, function(trans) {
        transitionFinally(trans);
    });
    function transitionFinally() {
        $timeout.cancel(inlineLoadingTimeoutPromise);
        $timeout(function() {
            //After the new view is loaded, the inlineLoading screen is a part
            //of that new template.  If this is changed on the same cycle, then
            //it's never visible on the new template so it doesn't fade out properly
            //so need to wait till the next cycle to turn it off so it fades
            $scope.inlineLoading = false;
        });
    }

    $scope.debugCoords = function() {
        $(window).mousemove(function(e) {
            $('.coordinates').html("pageX:" + e.pageX + " | | | " +"pageY:" + e.pageY + " | | | " +"clientX:" + e.clientX + " | | | " +"clientY:" + e.clientY);
        });
    };

    $scope.testError = function(msg) {
        throw new Error(msg);
    };

}]);
